'use client';

import { useRouter } from "next/navigation";
import { RouterName } from "@/lib/enum/RouterEnum";
import './textHeader.scss'

const TextHeader = () => {
  const router = useRouter();

  const _goHome = () => {
    router.push(RouterName.dashboard);
  };

  return (
    <div id='image-content-home' className={'image-content-home'} onClick={_goHome}>
      <img 
        src="/assets/gif/TOL_512.gif" 
        alt="The Other Lab" 
        width={512}
        height={512}
        style={{ width: '100%', height: 'auto' }} 
      />
    </div>
  )
}

export default TextHeader;
